import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthService} from '../../shared/services/auth.service';
import {ApiAmenaService} from './api-amena.service';
import {BehaviorSubject, Subject} from 'rxjs';
import {FormGroup} from '@angular/forms';
import { environment } from 'src/environments/environment';
import { fillZipCode, getNameStreet, searchRoadType } from 'src/app/utils/normalizerFunctions';
import { AlertDialogComponent } from 'src/app/shared/components/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root'
})
export class DraftService {
    public pdvDraft: any;
    public orderDraft: any;
    public normalizaDraft: any;
    public coberturaDraft: any;
    public movilPackDraft: any;
    public userDataDraft: any;
    public bankDataDraft: any;
    public order_idDraft: any;
    public datosTipoVia: any;
    public isCompletedOrder: boolean = false;
    public navigateAwaySelection$: Subject<boolean> = new Subject<boolean>();
    public activacionCompletada: BehaviorSubject<boolean>;

    constructor(
        private apiAmena: ApiAmenaService,
        protected http: HttpClient,
        private auth: AuthService,
        private matDialog: MatDialog
    ) {
        this.order_idDraft = new BehaviorSubject<any>(null);
        this.activacionCompletada = new BehaviorSubject<boolean>(false);
        // Marcamos la orden como un borrador
        this.orderInit();

        // Recuperamos los datos del PDV
        this.apiAmena.getPDV()
            .subscribe(data => {
                this.pdvDraft = data;
                if (this.pdvDraft !== null) {
                    this.setPdvInOrder();
                }
            });

        this.apiAmena.getDatosTipoVia()
            .subscribe(data => {
                this.datosTipoVia = data;
            });

        // Variable para no reprocesar ordenes ya enviadas
        this.getActivacionCompletada()
            .subscribe(data => {
                this.isCompletedOrder = data;
            });
    }

    orderInit() {
        this.orderDraft = null;
        this.normalizaDraft = null;
        this.coberturaDraft = null;
        this.movilPackDraft = null;
        this.userDataDraft = null;
        this.bankDataDraft = null;
        this.orderDraft = {
            draft: true,
            order_id: '',
            rate_id: '',
            customer: {},
            mobiles: []
        };
    }

    getHeaders() {
        const token = 'Bearer ' + this.auth.getToken();

        return new HttpHeaders({
            Authorization: token,
            'Content-Type': 'application/json'
        });
    }

    getOrderIdDraft() {
        return this.order_idDraft.asObservable();
    }

    // Variable que solo se setea si se completo el alta
    getActivacionCompletada() {
        return this.activacionCompletada.asObservable();
    }

    // Variable que solo se setea si se completo el alta
    setActivacionCompletada(value) {
        this.activacionCompletada.next(value);
    }

    setOrderIdDraft(data) {
        this.order_idDraft.next(data);
    }

    // Guardamos el ID de una orden a retomar
    setResumeOrderDraftId(data) {
        this.orderDraft.order_id = data;
    }

    setPdvInOrder() {
        this.orderDraft.pdv = {
            sfid: this.pdvDraft.sfids.amena,
            telesales: this.pdvDraft.info.telesales,
            third_party_verification: false,
            without_logistic: true,
            fixSfid: this.pdvDraft.sfids.amena_fijo
        };
    }

    setNormalizaInOrder() {
        this.orderDraft.customer.installation_address = {
            country: '',
            province: this.normalizaDraft.provinciaNormaliza,
            city: this.normalizaDraft.localidadNormaliza,
            post_code: fillZipCode(this.normalizaDraft.codigoPostalNormaliza),
            street_type: this.getTypeStreet(this.normalizaDraft.tipoViaNormaliza),
            street_name: this.normalizaDraft.nombreViaNormaliza,
            street_name2: '',
            street_number: this.normalizaDraft.numeroNormaliza,
            staircase_number: '',
            floor_number: '',
            apartment_number: ''
        };
        // Iniciamos broadband para que la order se marque como convergente
        this.orderDraft.broadband = {
            technology_access: '',
            msisdn: '', // Número fijo a portar
            service_provider_id: '', // Operador desde el cual se va a portar
            cima_arvato_code: '',
            cima_ine_town_code: '',
            cima_gescal_code: '',
            cima_unique_entity: '',
            cima_portal_code: '',
            miga_code: '',
            cima_block_code: '',
            cima_bis_code: '',
            cima_stair_code: '',
            cima_stair_other_code: '',
            cp_vat: '',
            cp_price: '',
            cp_price_without_vat: ''
        };
        // this.saveDraft();
    }

    setCoberturaInOrder() {
        this.orderDraft.broadband = {
            technology_access: '',
            msisdn: this.coberturaDraft.portabilidadFijo, // Número fijo a portar
            service_provider_id: this.coberturaDraft.serviceProviderFijo, // Operador desde el cual se va a portar
            cima_arvato_code: this.coberturaDraft.resultadoConsultaCobertura && this.coberturaDraft.resultadoConsultaCobertura !== '' ? this.coberturaDraft.resultadoConsultaCobertura.cimaArvatoCode : '',
            cima_ine_town_code: this.coberturaDraft.resultadoConsultaCobertura && this.coberturaDraft.resultadoConsultaCobertura !== '' ? this.coberturaDraft.resultadoConsultaCobertura.cimaINETownCode : '',
            cima_gescal_code: this.coberturaDraft.resultadoConsultaCobertura && this.coberturaDraft.resultadoConsultaCobertura !== '' ? this.coberturaDraft.resultadoConsultaCobertura.cimaGescalCode : '',
            cima_unique_entity: this.coberturaDraft.resultadoConsultaCobertura && this.coberturaDraft.resultadoConsultaCobertura !== '' ? this.coberturaDraft.resultadoConsultaCobertura.cimaUniqueEntity : '',
            cima_portal_code:this.coberturaDraft.resultadoConsultaCobertura && this.coberturaDraft.resultadoConsultaCobertura !== '' ?  this.coberturaDraft.resultadoConsultaCobertura.cimaPortalCode : '',
            miga_code: this.coberturaDraft.resultadoConsultaCobertura && this.coberturaDraft.resultadoConsultaCobertura !== '' ? this.coberturaDraft.resultadoConsultaCobertura.migaCode : '',
            cima_block_code: this.coberturaDraft.resultadoConsultaCobertura && this.coberturaDraft.resultadoConsultaCobertura !== '' ? this.coberturaDraft.resultadoConsultaCobertura.cimaBlockCode : '',
            cima_bis_code: this.coberturaDraft.resultadoConsultaCobertura && this.coberturaDraft.resultadoConsultaCobertura !== '' ? this.coberturaDraft.resultadoConsultaCobertura.cimaBisCode : '',
            cima_stair_code: this.coberturaDraft.resultadoConsultaCobertura && this.coberturaDraft.resultadoConsultaCobertura !== '' ? this.coberturaDraft.resultadoConsultaCobertura.cimaStairCode : '',
            cima_stair_other_code: this.coberturaDraft.resultadoConsultaCobertura && this.coberturaDraft.resultadoConsultaCobertura !== '' ? this.coberturaDraft.resultadoConsultaCobertura.cimaStairOtherCode : '',
            cp_vat: this.coberturaDraft.cp_vat ? this.coberturaDraft.cp_vat : null,
            cp_price: this.coberturaDraft.cp_price ? this.coberturaDraft.cp_price : null,
            cp_price_without_vat: this.coberturaDraft.cp_price_without_vat ? this.coberturaDraft.cp_price_without_vat : null
        };

        if (this.coberturaDraft.resultadoConsultaCobertura && this.coberturaDraft.resultadoConsultaCobertura !== '' && this.coberturaDraft.resultadoConsultaCobertura.hasOwnProperty('technology')) {
            if (this.coberturaDraft.resultadoConsultaCobertura.technology[0]) {
                this.orderDraft.broadband.technology_access = this.coberturaDraft.resultadoConsultaCobertura.technology[0];
            }
        }

        if (this.coberturaDraft.resultadoConsultaCobertura && this.coberturaDraft.resultadoConsultaCobertura !== '' && this.coberturaDraft.resultadoConsultaCobertura.hasOwnProperty('access')) {
            if (this.coberturaDraft.resultadoConsultaCobertura.access !== null) {
                this.orderDraft.broadband.technology_access = this.coberturaDraft.resultadoConsultaCobertura.access;
            }
        }

        this.orderDraft.customer.installation_address = {
            country: '',
            province: this.coberturaDraft.provinciaCobertura,
            city: this.coberturaDraft.localidadCobertura,
            post_code: fillZipCode(this.coberturaDraft.codigoPostalCobertura),
            street_type: this.getTypeStreet(this.coberturaDraft.tipoViaCobertura),
            street_name: this.coberturaDraft.nombreViaCobertura,
            street_name2: '',
            street_number: this.coberturaDraft.numeroCobertura,
            staircase_number: this.coberturaDraft.escaleraCobertura,
            floor_number: this.coberturaDraft.plantaCobertura,
            apartment_number: this.coberturaDraft.numeroApartamento
        };
    }

    setRate() {
        // Añadimos la tarifa
        if (!this.orderDraft.hasOwnProperty('rate_id') && this.movilPackDraft.rate.rate_id !== null) {
            this.orderDraft.rate_id = this.movilPackDraft.rate.rate_id;
        }
        // Añadimos la tecnología de la tarifa añadida, solo en caso de convergencia
        if (this.movilPackDraft.hasOwnProperty('rate') && this.movilPackDraft.rate !== null) {
            if (this.movilPackDraft.rate.hasOwnProperty('access')) {
                this.orderDraft.broadband.technology_access = this.movilPackDraft.rate.access;
            }
        }
        // Comprobamos si ya se ha añadido este item y solo se esta editando
        if(this.movilPackDraft.stepper_index !== null) {
            const isEdit = this.search(this.movilPackDraft.stepper_index, this.orderDraft.mobiles);
            // Añadimos los datos de la portabilidad según el caso
            if (isEdit === false) {
                this.addMobile();
            } else {
                this.changeMobile();
            }
        }

    }

    addMobile() {
        const tmp = {
            msisdn: this.movilPackDraft.portability_phone,
            old_iccid: this.movilPackDraft.portability_iccid ? this.movilPackDraft.portability_iccid : '',
            new_iccid: this.movilPackDraft.iccid ? this.movilPackDraft.iccid : '',
            old_contract_type: this.movilPackDraft.portability_type_client ? this.movilPackDraft.portability_type_client : '',
            service_provider_id: this.movilPackDraft.portability_operator ? this.movilPackDraft.portability_operator : '',
            terminal_id: this.movilPackDraft.terminal ? this.movilPackDraft.terminal.terminal_id : '',
            terminal_vap: this.movilPackDraft.terminal_payment_type === 'VAP',
            principal: this.checkIsFirstLine(),
            rate_id: this.movilPackDraft.rate.rate_id,
            stepper_index: this.movilPackDraft.stepper_index,
            resegmentation: this.movilPackDraft.resegmentation ? this.movilPackDraft.resegmentation : '',
            resegmentation_from_type: this.movilPackDraft.resegmentation_from_type ? this.movilPackDraft.resegmentation_from_type : '',
            resegmentation_type: this.movilPackDraft.resegmentation_type ? this.movilPackDraft.resegmentation_type : '',
            delivery_method: this.movilPackDraft.type_operation ? this.movilPackDraft.type_operation : '',
            cp_vat: this.movilPackDraft.cp_vat ? this.movilPackDraft.cp_vat : null,
            cp_price: this.movilPackDraft.cp_price ? this.movilPackDraft.cp_price : null,
            cp_price_without_vat: this.movilPackDraft.cp_price_without_vat ? this.movilPackDraft.cp_price_without_vat : null,
        };
        this.orderDraft.mobiles.push(tmp);
    }

    changeMobile() {
        for (let i = 0; i < this.orderDraft.mobiles.length; i++) {
            if (this.orderDraft.mobiles[i].stepper_index === this.movilPackDraft.stepper_index) {
                if (this.movilPackDraft.terminal === "" && this.movilPackDraft.stepper_index === 1 && this.orderDraft.mobiles[i].terminal_id !== "") {
                    const tmpTerminalId = this.orderDraft.mobiles[i].terminal_id;
                    const tmpTerminalVap = this.orderDraft.mobiles[i].terminal_vap;
                    this.orderDraft.mobiles[i] = {
                        msisdn: this.movilPackDraft.portability_phone,
                        old_iccid: this.movilPackDraft.portability_iccid ? this.movilPackDraft.portability_iccid : '',
                        new_iccid: this.movilPackDraft.iccid ? this.movilPackDraft.iccid : '',
                        old_contract_type: this.movilPackDraft.portability_type_client ? this.movilPackDraft.portability_type_client : '',
                        service_provider_id: this.movilPackDraft.portability_operator ? this.movilPackDraft.portability_operator : '',
                        terminal_id: tmpTerminalId,
                        terminal_vap: tmpTerminalVap,
                        principal: this.checkIsFirstLine(),
                        rate_id: this.movilPackDraft.rate.rate_id,
                        stepper_index: this.movilPackDraft.stepper_index,
                        resegmentation: this.movilPackDraft.resegmentation ? this.movilPackDraft.resegmentation : '',
                        resegmentation_from_type: this.movilPackDraft.resegmentation_from_type ? this.movilPackDraft.resegmentation_from_type : '',
                        resegmentation_type: this.movilPackDraft.resegmentation_type ? this.movilPackDraft.resegmentation_type : '',
                        delivery_method: this.movilPackDraft.type_operation ? this.movilPackDraft.type_operation : '',
                        cp_vat: this.movilPackDraft.cp_vat ? this.movilPackDraft.cp_vat : '',
                        cp_price: this.movilPackDraft.cp_price ? this.movilPackDraft.cp_price : '',
                        cp_price_without_vat: this.movilPackDraft.cp_price_without_vat ? this.movilPackDraft.cp_price_without_vat : '',
                    };
                } else {
                    this.orderDraft.mobiles[i] = {
                        msisdn: this.movilPackDraft.portability_phone,
                        old_iccid: this.movilPackDraft.portability_iccid ? this.movilPackDraft.portability_iccid : '',
                        new_iccid: this.movilPackDraft.iccid ? this.movilPackDraft.iccid : '',
                        old_contract_type: this.movilPackDraft.portability_type_client ? this.movilPackDraft.portability_type_client : '',
                        service_provider_id: this.movilPackDraft.portability_operator ? this.movilPackDraft.portability_operator : '',
                        terminal_id: this.movilPackDraft.terminal ? this.movilPackDraft.terminal.terminal_id : '',
                        terminal_vap: this.movilPackDraft.terminal_payment_type === 'VAP',
                        principal: this.checkIsFirstLine(),
                        rate_id: this.movilPackDraft.rate.rate_id,
                        stepper_index: this.movilPackDraft.stepper_index,
                        resegmentation: this.movilPackDraft.resegmentation ? this.movilPackDraft.resegmentation : '',
                        resegmentation_from_type: this.movilPackDraft.resegmentation_from_type ? this.movilPackDraft.resegmentation_from_type : '',
                        resegmentation_type: this.movilPackDraft.resegmentation_type ? this.movilPackDraft.resegmentation_type : '',
                        delivery_method: this.movilPackDraft.type_operation ? this.movilPackDraft.type_operation : '',
                        cp_vat: this.movilPackDraft.cp_vat ? this.movilPackDraft.cp_vat : '',
                        cp_price: this.movilPackDraft.cp_price ? this.movilPackDraft.cp_price : '',
                        cp_price_without_vat: this.movilPackDraft.cp_price_without_vat ? this.movilPackDraft.cp_price_without_vat : '',
                    };
                }
            }
        }

    }

    removeMobile(index) {
        this.orderDraft.mobiles.splice(index, 1);
    }

    // Busca en un array de objectos la cadena indicada
    search(nameKey, myArray) {
        for (var i = 0; i < myArray.length; i++) {
            if (myArray[i].stepper_index === nameKey) {
                return true;
            }
        }
        return false;
    }

    // Comprueba si es la linea principal
    checkIsFirstLine() {
        if (this.orderDraft.mobiles.length > 0) {
            if (this.orderDraft.mobiles[0].stepper_index === this.movilPackDraft.stepper_index) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

    setUserData() {
        this.orderDraft.customer.name = this.userDataDraft.firstName;
        this.orderDraft.customer.last_name = this.userDataDraft.surname1;
        this.orderDraft.customer.second_last_name = this.userDataDraft.surname2;
        this.orderDraft.customer.phone_number = this.userDataDraft.phone;
        this.orderDraft.customer.email = this.userDataDraft.email;
        this.orderDraft.customer.document_type = this.userDataDraft.doctype;
        this.orderDraft.customer.document = this.userDataDraft.doc;
        this.orderDraft.customer.nationality = this.userDataDraft.country;

        if (typeof this.userDataDraft.birthday === 'string') {
            this.orderDraft.customer.birth_date = this.userDataDraft.birthday !== '' ? this.userDataDraft.birthday : null ;
        } else if (this.userDataDraft.birthday === null) {
            this.orderDraft.customer.birth_date = null ;
        } else {
            this.orderDraft.customer.birth_date = this.userDataDraft.birthday.format('YYYY-MM-DD');
        }

        if (this.userDataDraft.sex !== null && this.userDataDraft.sex !== undefined) {
            this.orderDraft.customer.gender = this.userDataDraft.sex === 'M' ? 'male' : 'female';
        }
        this.orderDraft.customer.postal_address = this.getDirUser();
        this.orderDraft.customer.billing_address = this.getDirUser();

        // entrega movil
        if (this.userDataDraft.terminal_delivery && this.userDataDraft.terminal_delivery.courierData) {
            const courier = this.userDataDraft.terminal_delivery.courierData;
            this.orderDraft.customer.delivery_address = {
                country: 'Spain',
                province: courier.province,
                city: courier.city,
                name: courier.full_name,
                phone_number: courier.phone,
                post_code: fillZipCode(courier.zip),
                street_type: this.getTypeStreet(courier.road_type),
                street_name: getNameStreet(courier.address, this.datosTipoVia, 'code'),
                street_name2: '',
                street_number: courier.number,
                staircase_number: courier.stairway,
                floor_number: courier.floor,
                apartment_number: courier.door,
                additional_info: courier.additional_info
            };
            // Si había añadido otra dirección de entrega la borramos
            if (this.orderDraft.hasOwnProperty('correos')) {
                delete this.orderDraft.correos;
            }
        }

        // si se entrega en correos
        if (this.userDataDraft.terminal_delivery && this.userDataDraft.terminal_delivery.mailData) {
            const correos = this.userDataDraft.terminal_delivery.mailData;
            this.orderDraft.correos = {
                id: correos.id,
                name: correos.name,
                street_number: correos.address.streetNr,
                street_name: correos.address.streetName,
                street_type: this.getTypeStreet(correos.address.streetType),
                post_code: fillZipCode(correos.address.postcode),
                city: correos.address.city,
                province: correos.address.stateOrProvince,
                complete_address: correos.address.completeAddress,
                calendar: [],
                geographic_sub_address: []

            };
            for (const day of correos.calendar) {
                this.orderDraft.correos.calendar.push(
                    {
                        status: '',
                        day: day.day,
                        opening_times: day.openingTimesDescription,
                        hour_period: day.hourPeriod
                    }
                );
            }

            for (const subaddress of correos.address.geographicSubAddress) {
                this.orderDraft.correos.geographic_sub_address.push(
                    {
                        id: subaddress.id,
                        level_number: subaddress.levelNumber,
                        door: subaddress.door,
                        staircase: subaddress.staircase
                    }
                );
            }
            // Si había añadido otra dirección de entrega la borramos
            if (this.orderDraft.customer.hasOwnProperty('delivery_address')) {
                delete this.orderDraft.customer.delivery_address;
            }
        }
        // Entrega a la dirección del cliente
        if (this.userDataDraft.terminal_delivery && this.userDataDraft.terminal_delivery.type === 3) {
            this.orderDraft.customer.delivery_address = {
                country: 'Spain',
                province: this.userDataDraft.provincia,
                city: this.userDataDraft.localidad,
                name: this.userDataDraft.firstName + ' ' + this.userDataDraft.surname1 + ' ' + this.userDataDraft.surname2,
                phone_number: this.userDataDraft.phone,
                post_code: fillZipCode(this.userDataDraft.codigoPostal),
                street_type: this.getTypeStreet(this.userDataDraft.tipoVia),
                street_name: getNameStreet(this.userDataDraft.nombreVia, this.datosTipoVia, 'code'),
                street_number: `${this.userDataDraft.numero}`,
                staircase_number: this.userDataDraft.escalera,
                floor_number: this.userDataDraft.planta,
                apartment_number: this.userDataDraft.puerta
            };
            // Si había añadido otra dirección de entrega la borramos
            if (this.orderDraft.hasOwnProperty('correos')) {
                delete this.orderDraft.correos;
            }
        }

        if (this.orderDraft.customer.delivery_address && !this.userDataDraft.terminal_delivery) {
            this.orderDraft.customer.delivery_address = undefined;
        }
        // Si es una convergencia
        if (this.orderDraft.customer.hasOwnProperty('installation_address')) {
            this.orderDraft.customer.installation_address.country = 'Spain';
        }
    }

    setBankData() {
        this.orderDraft.customer.payment = {
            iban: this.bankDataDraft.bank_account,
            bank_name: '',
            document_type: this.bankDataDraft.account_doctype,
            document: this.bankDataDraft.account_doc,
            name: this.bankDataDraft.account_firstName,
            last_name: this.bankDataDraft.account_surname1,
            second_last_name: this.bankDataDraft.account_surname2
        };
    }

    saveDraft(isSaveModal = null) {
        if (this.pdvDraft !== null && this.isCompletedOrder === false) {
            this.setPdvInOrder();
        }

        if (Object.keys(this.orderDraft).length !== 0 && this.isCompletedOrder === false) {
            if (!(this.pdvDraft && this.pdvDraft.permissions && this.pdvDraft.permissions.SAMPLE_MODE && this.pdvDraft.permissions.SAMPLE_MODE === 'SAMPLE')) {
                this.apiAmena.createOrder(this.orderDraft)
                .subscribe((data: any) => {
                    if (data.msg) {
                        this.orderDraft.order_id = data.msg.orderId;
                        this.setOrderIdDraft(data.msg.orderId);
                        if (isSaveModal !== null) {
                            this.orderInit();
                        }
                    }
                });
            }            
        }
    }

    updateOrder(data: FormGroup) {
        if (data !== null && data.controls !== undefined) {
            this.updateNormaliza(data);
            this.updateCobertura(data);
            this.updateRate(data);
            this.updateUserData(data);
            this.updateUserDataBank(data);
        }
    }

    updateNormaliza(data: FormGroup) {
        if (data.getRawValue().hasOwnProperty('provinciaNormaliza')) {
            this.normalizaDraft = data.getRawValue();
            this.setNormalizaInOrder();
        }
    }

    updateCobertura(data: FormGroup) {
        if (data.getRawValue().hasOwnProperty('resultadoConsultaCobertura')) {
            this.coberturaDraft = data.getRawValue();
            this.setCoberturaInOrder();
        }
    }

    updateRate(data: FormGroup) {
        if (data.getRawValue().hasOwnProperty('rate')) {
            this.movilPackDraft = data.getRawValue();
            if (this.movilPackDraft.rate !== null) {
                // Si es una convergencia, cambiamos el stepper_index a 1
                if (this.orderDraft.hasOwnProperty('broadband') && this.movilPackDraft.stepper_index === 0) {
                    this.movilPackDraft.stepper_index = 1;
                }
                this.setRate();
            }
        }
    }

    updateUserData(data: FormGroup) {
        // Primera parte del paso 3, hasta el metodo de entrega de terminal
        if (data.getRawValue().hasOwnProperty('doctype') || data.contains('doctype')) {
            this.userDataDraft = data.getRawValue();
            this.setUserData();
        }
    }

    updateUserDataBank(data: FormGroup) {
        // Segunda parte del paso 3, cuenta bancaria
        if (data.getRawValue().hasOwnProperty('account_doctype') || data.contains('account_doctype')) {
            this.bankDataDraft = data.getRawValue();
            this.setBankData();
        }
    }

    getDirUser() {
        return {
            country: 'Spain',
            province: this.userDataDraft.provincia,
            city: this.userDataDraft.localidad,
            post_code: fillZipCode(this.userDataDraft.codigoPostal),
            street_type: this.getTypeStreet(this.userDataDraft.tipoVia),
            street_name: getNameStreet(this.userDataDraft.nombreVia, this.datosTipoVia, 'code'),
            street_name2: '',
            street_number: `${this.userDataDraft.numero}`,
            staircase_number: this.userDataDraft.escalera,
            floor_number: this.userDataDraft.planta,
            apartment_number: this.userDataDraft.puerta
        };
    }

    removeDraft(id_remove) {
        const url = environment.amenaEndpoint + 'order/' + `${id_remove}` + '/delete';
        return this.http.delete(url, {headers: this.getHeaders()});
    }

    getTypeStreet(value: string): string {
        if (this.datosTipoVia && this.datosTipoVia.length && value) {
            if (value.toLowerCase() === 'passatge') {
                value = 'pasaje';
            }
            const valueNormalized = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

            const tipoVia = this.datosTipoVia.filter(item => {
                const codeNormalized = item.code.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

                return valueNormalized.toLowerCase() === codeNormalized.toLowerCase();
            });

            if (tipoVia && tipoVia.length) {
                const code = tipoVia[0].code;

                return code;
            } else {
                return 'CALLE';
            }
        }

        return 'CALLE';
    }
}
